export enum ERequestType {
  EXPORT_SHAPEFILE = 'EXPORT_ARTIFACTS',
  DS_AUTOMATION = 'DS_SITE_UPLOAD',
  SITE_INGESTION = 'SITE_INGESTION',
  BNG_INGESTION = 'PD_PLAN_INGESTION',
  EXPORT_FEATURES = 'FEATURE_EXPORT',
  IMAGERY_FEASIBILITY = 'IMAGERY_FEASIBILITY',
  IMAGERY_PLACE_ORDER = 'IMAGERY_PLACE_ORDER',
  LABELLER = 'LABELLER',
  PD_ARTIFACT_EXPORT = 'PD_ARTIFACT_EXPORT',
  METRIC_TOOL_EXPORT = 'METRIC_TOOL_EXPORT',
}

export interface IOperation {
  value: ERequestType
  label: string
  icon: React.ReactNode
  description: string
  requiresConfig: boolean
  requestType: ERequestType
}

export interface IBulkOptionsConfig {
  [ERequestType.DS_AUTOMATION]: {
    dsAutomationEnabled: boolean
  }
  [ERequestType.EXPORT_FEATURES]: {
    layerOptions: Array<{
      layerName: string
      layerId: string
    }>
  }
}
